"use client";
import { jsx as i } from "react/jsx-runtime";
import { Button as _ } from "../../primitives/button/button.js";
import v from "clsx";
import { useState as h, useCallback as T, useEffect as x } from "react";
import '../../assets/scroll-to.css';const d = {
  "scroll-to--sticky": "_scroll-to--sticky_19966_1",
  "scroll-to--sticky-visible": "_scroll-to--sticky-visible_19966_10"
}, B = ({
  target: o,
  scrollEndOfElement: s = !1,
  behavior: c = "smooth",
  offset: u = 0,
  onClick: r,
  sticky: n,
  stickyThreshold: m = 200,
  className: w,
  ...a
}) => {
  const [f, p] = h(!1), y = T(() => {
    let t = 0, l = null;
    if (typeof o == "number")
      t = o;
    else {
      const e = typeof o == "string" && o !== "" ? document.querySelector(o) : o && "current" in o ? o.current : null;
      if (e) {
        const { top: b, bottom: S } = e.getBoundingClientRect();
        t = (s ? S : b) + window.scrollY, e.id && (l = e.id);
      }
    }
    if (window.scrollTo({ top: t + u, behavior: c }), l) {
      const e = `${window.location.pathname}${window.location.search}#${l}`;
      history.pushState(null, "", e);
    }
  }, [c, s, o, u]);
  return x(() => {
    if (!n) return;
    let t = !1;
    const l = () => {
      t || (window.requestAnimationFrame(() => {
        p(window.scrollY > m), t = !1;
      }), t = !0);
    };
    return l(), window.addEventListener("scroll", l), () => window.removeEventListener("scroll", l);
  }, [n, m]), /* @__PURE__ */ i(
    "button",
    {
      type: "button",
      className: v(
        {
          [d["scroll-to--sticky"]]: n,
          [d["scroll-to--sticky-visible"]]: n && f
        },
        w
      ),
      onClick: (t) => {
        r == null || r(t), y();
      },
      ...a
    }
  );
}, L = ({ children: o, ...s }) => /* @__PURE__ */ i(_, { ...s, asChild: !0, children: /* @__PURE__ */ i(B, { children: o }) });
export {
  L as ScrollToButton,
  B as ScrollToElement
};
